import { Stack } from '@mui/material'
import { useMemo } from 'react'
import { assertNever } from 'utils/type-guard/assertNever'
import { RequestMobileCard } from '@omnea-app/fe-requests/RequestMobileCard'
import { RequestRow } from '@omnea-app/fe-requests/useRequestTableRows'
import { TaskMobileCard } from '@omnea-app/fe-tasks/TaskMobileCard'
import { TaskRow } from '@omnea-app/fe-tasks/useTaskTableRows'
import { sortAndSliceRows } from './sortRows'
import type { SortModel } from './sortRows'
import type { DashboardTableType } from './types'

interface Props {
  rows: TaskRow[] | RequestRow[]
  type: DashboardTableType
  defaultSortModel?: SortModel
}

export const MobileCards = ({ rows, type, defaultSortModel }: Props) => {
  const sortedRows = useMemo(() => sortAndSliceRows<TaskRow | RequestRow>(rows, defaultSortModel), [rows, defaultSortModel])

  return (
    <Stack spacing={3}>
      {sortedRows.map((row) => {
        switch (type) {
          case 'REQUESTS':
            return <RequestMobileCard key={row.id} request={row as RequestRow} />
          case 'TASKS':
            return <TaskMobileCard key={row.id} task={row as TaskRow} />
          default:
            assertNever(type)
            return null
        }
      })}
    </Stack>
  )
}
